// eslint-disable-next-line import/extensions
import { BankSearchMode } from '../../types/global';
import store from './store';

const isLoggingEnabled = false;

const appName = 'app_filialsuche';

/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
// see log(), track(), ACTION, VIRTUAL_PAGE at the end of this file

export const tracker = {
  trackInputLocationLink() {
    log('trackInputLocationLink()');
    track(ACTION, {
      virtualTarget: `${appName}.Suchergebnisseite`,
      elementType: 'Link',
      elementLabel: 'Aktueller_Standort',
    });
  },

  trackInputButton() {
    log('trackInputButton()');
    track(ACTION, {
      virtualTarget: `${appName}.Suchergebnisseite`,
      elementType: 'Button',
      elementLabel: 'Suche',
    });
  },

  trackInputEnter() {
    log('trackInputEnter()');
    track(ACTION, {
      virtualTarget: `${appName}.Suchergebnisseite`,
      elementType: 'Button',
      elementLabel: 'Suche',
    });
  },

  trackInputAutocompleteEntry() {
    log('trackInputAutocompleteEntry()');
    track(ACTION, {
      virtualTarget: `${appName}.Suchergebnisseite`,
      elementType: 'Link',
      elementLabel: 'Suche',
    });
  },

  trackExecuteBankSearch() {
    log('trackExecuteBankSearch()');
    track(VIRTUAL_PAGE, {
      virtualContentGroups: [appName, 'Suchergebnisseite'],
      customParameter: {
        1: store.state.resultsTotal.length,
      },
      customECommerceParameter: {
        2: 'Filialsuche',
        44: getParam44(),
      },
      internalSearch: store.state.selectedPlaceName,
    });
  },

  trackFilterChange() {
    // log('trackFilterChange()');
    // track(ACTION, {
    //   virtualContentGroups: [
    //     appName,
    //     'Suchergebnisseite',
    //   ],
    //   virtualTarget: `Jetzt_einen_Termin_bei_Ihrer_Bank_vor_Ort_vereinbaren.${appName}.Suchergebnisseite`,
    //   elementType: 'Button',
    //   elementLabel: store.state.activeFilterValue,
    // });
  },

  /**
   * List entries (cards) on desktop shall track as 'Teaser',
   * clicks on map markers shall track as 'Button'.
   * In the light mode, the tracking differs from the regular mode.
   * @param type
   * @param mode
   */
  trackBankSelect(
    type: 'Teaser' | 'Button' | 'Link',
    mode: BankSearchMode = 'regular'
  ) {
    log('trackBankSelect()');
    let attributes;
    if (mode === 'light') {
      attributes = {
        externalTarget: store.state.selectedBank.url,
        elementLabel: (window as any).ui.services?.i18n?.translate('bankSearch')
          .onlineBankingLinkText,
      };
    } else {
      attributes = {
        virtualContentGroups: [appName, 'Suchergebnisseite'],
        virtualTarget: `${appName}.${getParamFormName()}`,
        elementLabel: store.state.selectedBank.name,
      };
    }
    track(ACTION, {
      ...attributes,
      elementType: type,
    });
  },

  trackLoadMore() {
    // log('trackLoadMore()');
    // track(ACTION, {
    //   virtualContentGroups: [
    //     appName,
    //   ],
    //   virtualTarget: 'Suchergebnisseite',
    //   elementType: 'Link',
    //   elementLabel: 'Mehr_laden',
    // });
  },

  trackOverlayBackLink() {
    log('trackOverlayBackLink()');
    track(ACTION, {
      virtualContentGroups: [appName, getParamFormName()],
      virtualTarget: `${appName}.Suchergebnisseite`,
      elementType: 'Link',
      elementLabel: 'Zurück_zur_Filialauswahl',
    });
  },

  trackBankDirectionsLink() {
    log('trackBankDirectionsLink()');
    track(ACTION, {
      virtualContentGroups: [appName, getParamFormName()],
      externalTarget: 'https://www.google.de/maps',
      elementType: 'Link',
      elementLabel: 'Routenplaner',
    });
  },

  trackBankMailLink() {
    log('trackBankMailLink()');
    track(ACTION, {
      virtualContentGroups: [appName, getParamFormName()],
      target: store.state.selectedBank.email,
      elementType: 'Link',
      elementLabel: 'E-Mail',
    });
  },

  trackBankWebsiteLink() {
    log('trackBankWebsiteLink()');
    track(ACTION, {
      virtualContentGroups: [appName, getParamFormName()],
      externalTarget: store.state.selectedBank.url,
      elementType: 'Link',
      elementLabel: 'Webseite',
    });
  },

  trackBankPhoneLink() {
    log('trackBankPhoneLink()');
    track(ACTION, {
      virtualContentGroups: [appName, getParamFormName()],
      target: `${store.state.selectedBank.phoneArea}${store.state.selectedBank.phoneNumber}`,
      elementType: 'Link',
      elementLabel: `${store.state.selectedBank.phoneArea}${store.state.selectedBank.phoneNumber}`,
    });
  },

  trackBankOpeningHoursButton() {
    // log('trackBankOpeningHoursButton()');
    // track(ACTION, {
    //   virtualContentGroups: [
    //     appName,
    //   ],
    //   virtualTarget: 'form_Terminvereinbarung',
    //   elementType: 'Button',
    //   elementLabel: 'Öffnungszeiten',
    // });
  },

  trackBankContactButton() {
    // log('trackBankContactButton()');
    // track(ACTION, {
    //   virtualContentGroups: [
    //     appName,
    //   ],
    //   virtualTarget: 'form_Terminvereinbarung',
    //   elementType: 'Button',
    //   elementLabel: 'Kontakt',
    // });
  },

  trackMobileListView() {
    // log('trackMobileListView()');
    // track(ACTION, {
    //   virtualContentGroups: [
    //     appName,
    //   ],
    //   virtualTarget: 'Suchergebnisseite',
    //   elementType: 'Button',
    //   elementLabel: 'Listenansicht',
    // });
  },

  trackMobileMapView() {
    // log('trackMobileMapView()');
    // track(ACTION, {
    //   virtualContentGroups: [
    //     appName,
    //     'Suchergebnisseite',
    //   ],
    //   virtualTarget: 'Suchergebnisseite',
    //   elementType: 'Button',
    //   elementLabel: 'Kartenansicht',
    // });
  },

  trackInitialFormPage(bankCode: number, bankName: string) {
    log('trackInitialFormPage()');
    track(VIRTUAL_PAGE, {
      virtualContentGroups: [appName, getParamFormName()],
      customECommerceParameter: {
        2: 'Filialsuche',
        8: bankCode,
        39: bankName,
        44: getParam44(),
      },
    });
  },

  trackFormClose() {
    // log('trackFormClose()');
    // track(ACTION, {
    //   virtualTarget: appName,
    //   elementType: 'Button',
    //   elementLabel: 'Schließen',
    // });
  },
};

// / / / / / /  H E L P E R S  / / / / / / / / / / /

type TrackingType = {
  eventInfo: {
    eventType: 'Action' | 'VirtualPage';
  };
  category?: {
    area: 'Content';
  };
};

const VIRTUAL_PAGE: TrackingType = {
  eventInfo: {
    eventType: 'VirtualPage',
  },
};

const ACTION: TrackingType = {
  eventInfo: {
    eventType: 'Action',
  },
  category: {
    area: 'Content',
  },
};

/**
 * Merges `type` and `attributes` objects and passes resulting object to tracking service.
 *
 * @param type type of webtrekk request, either ACTION or VIRTUAL_PAGE
 * @param attributes object with tracking data
 */
function track(type: TrackingType, attributes: Record<string, unknown>) {
  const trackingData = { ...type, attributes };
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  (window as any).ui?.services?.tracking?.track(trackingData);
}

function log(message: string) {
  /* eslint-disable-next-line no-console */
  if (isLoggingEnabled) console.log(message);
}

function getParam44() {
  return store.state.isRestoredDataFromLocalstorage
    ? 'Cookie_ja'
    : 'Cookie_nein';
}

function getParamFormName() {
  return `form_${store.state.formName}`; // form_Kontaktanfrage_Ansprechpartnersuche
}
